import type { IValidationField } from 'hooks/useValidations/types';
import * as yup from 'yup';

export default function seedBagSize({ label = '' }: IValidationField) {
  return yup
    .string()
    .label(label)
    .default('')
    .when('itemReference', {
      is: (val: boolean) => val,
      then: (schema) => schema.required(),

      otherwise: (schema) => schema,
    });
}
